<div class="container season-pass-checkout-page">
    <div class="content-checkout">
        <div class="loading-container" *ngIf="!loaded || waiting">
            <ng-lottie class="lottie" [options]="{path: 'assets/lotties/loading.json'}"
                containerClass="loading-box"></ng-lottie>
        </div>

        <!-- Error de carga: sin abono o sin importe configurado no hay nada que pagar -->
        <div class="list-products-cart item-checkout" *ngIf="loaded && loadErrorMsg">
            <div class="flex-continue-back" (click)="goToMyMemberships()">
                <i class="fa-light fa-arrow-left"></i>
                <p class="m-0">Volver a mis abonos</p>
            </div>

            <p class="title-item-checkout">Pago del abono</p>

            <div class="time-checkout">
                <p class="m-0">
                    <i class="fa-light fa-circle-exclamation icon-primary" style="margin-right: 8px;"></i>
                    {{loadErrorMsg}}
                </p>
            </div>
        </div>

        <!-- Columna izquierda: datos del abono -->
        <div class="list-products-cart item-checkout" *ngIf="loaded && !loadErrorMsg && seasonPass">
            <div class="flex-continue-back" (click)="goBack()">
                <i class="fa-light fa-arrow-left"></i>
                <p class="m-0">Volver a mis abonos</p>
            </div>

            <p class="title-item-checkout">Pago del abono</p>

            <div class="time-checkout">
                <p class="m-0">
                    <i class="fa-light fa-circle-info icon-primary" style="margin-right: 8px;"></i>
                    Tu abono se activará automáticamente en cuanto se confirme el pago.
                </p>
            </div>

            <!-- Datos del abono -->
            <div class="pass-card">
                <div class="pass-card-icon">
                    <i class="fa-light fa-id-card"></i>
                </div>
                <div class="pass-card-info">
                    <p class="pass-card-title m-0">{{seasonPass.season?.name}}</p>
                    <p class="pass-card-company m-0" *ngIf="seasonPass.space?.name">{{seasonPass.space?.name}}</p>

                    <div class="pass-card-rows">
                        <div class="pass-row" *ngIf="seasonPass.user?.name">
                            <i class="fa-light fa-user icon-primary"></i>
                            <p class="m-0">{{seasonPass.user?.name}}<span *ngIf="seasonPass.user?.nif"> · {{seasonPass.user?.nif}}</span></p>
                        </div>
                        <div class="pass-row" *ngIf="seatDisplay">
                            <i class="fa-light fa-chair icon-primary"></i>
                            <p class="m-0">{{seatDisplay}}</p>
                        </div>
                        <div class="pass-row">
                            <i class="fa-light fa-hashtag icon-primary"></i>
                            <p class="m-0">Nº de abonado: {{seasonPass.member_number}}</p>
                        </div>
                        <div class="pass-row" *ngIf="seasonPass.category?.name">
                            <i class="fa-light fa-user-tag icon-primary"></i>
                            <p class="m-0">{{seasonPass.category?.name}}</p>
                        </div>
                    </div>
                </div>
                <span class="pass-status-badge">{{seasonPass.status?.name}}</span>
            </div>

            <!-- Con una sola opción no hay nada que elegir: se paga esa -->
            <ng-container *ngIf="products.length > 1">
                <mat-divider></mat-divider>

                <p class="section-title">Elige tu abono</p>
                <div class="products-list">
                    <button type="button" class="product-option" *ngFor="let product of products"
                        [class.selected]="selectedProduct?.id === product.id" (click)="selectProduct(product)">
                        <i class="fa-check-icon fa-solid fa-circle-check"></i>
                        <div class="product-option-info">
                            <p class="product-option-name m-0">{{product.name}}</p>
                            <p class="product-option-desc m-0" *ngIf="product.description">{{product.description}}</p>
                        </div>
                        <span class="product-option-price">{{product.price | number: '1.2-2'}} €</span>
                    </button>
                </div>
            </ng-container>
        </div>

        <!-- Columna derecha: resumen y pago -->
        <div class="resume-checkout item-checkout" *ngIf="loaded && !loadErrorMsg && seasonPass">
            <p class="title-item-checkout">Resumen</p>

            <div class="number-event d-flex align-items-center justify-content-between">
                <div class="d-flex title-event" style="gap: 10px;">
                    <span>1 x</span>
                    <span>{{selectedProduct?.name}}</span>
                </div>
                <p class="total-price-event title-event m-0">{{subtotal | number: '1.2-2'}} €</p>
            </div>
            <div class="detail-resume">
                <div class="date-option d-flex align-items-center">
                    <i class="fa-light fa-calendar-range icon-primary"></i>
                    <p class="m-0">{{seasonPass.season?.name}}</p>
                </div>
            </div>

            <div class="order-summary-section">
                <mat-divider></mat-divider>

                <div class="summary-row">
                    <span class="summary-label">Subtotal</span>
                    <span class="summary-value">{{subtotal | number: '1.2-2'}} €</span>
                </div>

                <div class="summary-row" *ngIf="gestionPrice > 0">
                    <span class="summary-label">Gastos de gestión</span>
                    <span class="summary-value">{{gestionPrice | number: '1.2-2'}} €</span>
                </div>

                <mat-divider></mat-divider>

                <div class="summary-row summary-row-total">
                    <span class="summary-label-total">Total <span class="iva-label">(IVA Inc.)</span></span>
                    <span class="summary-value-total">{{totalPrice | number: '1.2-2'}} €</span>
                </div>
            </div>

            <!-- Selector de método de pago -->
            <div class="payment-method-selector">
                <p class="title-payment-method">Método de pago</p>
                <div class="payment-method-options">
                    <button type="button" class="payment-method-option" [class.selected]="redsysMethod === 'card'"
                        (click)="selectPaymentMethod('card')">
                        <i class="fa-check-icon fa-solid fa-circle-check"></i>
                        <div class="option-content">
                            <i class="fa-light fa-credit-card"></i>
                            <span>Tarjeta</span>
                        </div>
                    </button>
                    <button type="button" class="payment-method-option" [class.selected]="redsysMethod === 'xpay'"
                        [class.disabled]="citylokPaymentMethodsDisabled" [disabled]="citylokPaymentMethodsDisabled"
                        [title]="citylokPaymentMethodsDisabled ? 'Método de pago no disponible' : ''"
                        (click)="selectPaymentMethod('xpay')">
                        <i class="fa-check-icon fa-solid fa-circle-check"></i>
                        <div class="option-content wallet-logos">
                            <img src="assets/img/payment-methods/apple-pay.svg" alt="Apple Pay" class="apple-pay-icon">
                            <span class="logo-divider"></span>
                            <img src="assets/img/payment-methods/google-pay.svg" alt="Google Pay" class="google-pay-icon">
                        </div>
                    </button>
                    <button type="button" class="payment-method-option" [class.selected]="redsysMethod === 'bizum'"
                        [class.disabled]="citylokPaymentMethodsDisabled" [disabled]="citylokPaymentMethodsDisabled"
                        [title]="citylokPaymentMethodsDisabled ? 'Método de pago no disponible' : ''"
                        (click)="selectPaymentMethod('bizum')">
                        <i class="fa-check-icon fa-solid fa-circle-check"></i>
                        <div class="option-content">
                            <img src="assets/img/payment-methods/bizum.svg" alt="Bizum" class="bizum-icon">
                            <span>Bizum</span>
                        </div>
                    </button>
                </div>
            </div>

            <div class="checkbox-conditions">
                <mat-checkbox [(ngModel)]="checkAcceptConditions" color="primary">
                    Acepto los <span class="link-terms pointer-in">términos y condiciones de Citylok.</span>
                </mat-checkbox>
            </div>

            <button class="w-100 primary-button solid btn-finish"
                [class.disabled]="!checkAcceptConditions || !selectedProduct"
                [disabled]="!loaded || waiting || !checkAcceptConditions || !selectedProduct" (click)="pay()">
                Pagar {{totalPrice | number: '1.2-2'}} €
            </button>
        </div>
    </div>
</div>
